export default "__VITE_ASSET__De6IRECd__"